import { MultiLookupMultiSelectDropDown } from '@ui-kit'
import { MultiLookupRendererProps } from '../types/formRenderer.types'
import {
  DeepRequired,
  FieldErrors,
  FieldValues,
  Path,
  PathValue,
} from 'react-hook-form'
import { getEntityDataByEntityIdLayoutIdApi } from '@app-store'
import { useEffect, useState } from 'react'

const MultiLookupRender = <T extends FieldValues>({
  element,
  errors,
  control,
  setValue,
  dataQaId,
  ...rest
}: MultiLookupRendererProps<T>) => {
  const [entityData, setEntityData] = useState([])

  const fetchEntityData = async (
    entityId: string,
    entityName: string,
    layoutId: string
  ) => {
    try {
      const res = await getEntityDataByEntityIdLayoutIdApi({
        id: entityId,
        name: entityName,
        layoutId: layoutId,
      })
      setEntityData(res.data)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    fetchEntityData(
      element?.meta?.relationship?.target_entity_id?.toString() ?? '',
      element?.meta?.relationship?.target_entity?.toString() ?? '',
      element?.meta?.list_view_layout_id?.toString() ?? ''
    )
  }, [element.meta])

  return (
    <MultiLookupMultiSelectDropDown
      name={element.keyName as Path<T>}
      errors={errors as unknown as FieldErrors<DeepRequired<T>['toString']>}
      label={element.meta.label}
      control={control}
      isSearchable={true}
      onChange={(e) => {
        const values: { id: number; name: string }[] = []
        e?.forEach((item) => {
          values.push(item.value)
        })
        setValue(element.keyName as Path<T>, values as PathValue<T, Path<T>>)
      }}
      options={entityData.map((data: { name?: string; id: number }) => {
        return {
          label: data?.name ?? '-',
          value: { id: data.id, name: data?.name ?? '-' },
        }
        // as DropdownType<T,{ name: string; id: number }>
      })}
      // options={entityData.map((data: { name: string; id: number }) => {
      //   return {
      //     label: data?.name,
      //     value: data?.id.toString(),
      //   }
      // })}
      dataQaId={dataQaId}
      {...rest}
    />
  )
}

export default MultiLookupRender
